module.exports = __webpack_public_path__ + "img/401654912.722c8739.jpg";